import React, { useState } from 'react';
import { Modal, Typography } from 'antd';
import { useHistory } from 'react-router-dom';

const { Paragraph } = Typography;

const Banner = () => {
  const [showModal, setShowModal] = useState(true);
  const history = useHistory();

  const handleAccept = () => {
    setShowModal(false);
  };

  const handleReject = () => {
    history.goBack();
  };

  return (
    <Modal
      title="Disclaimer"
      visible={showModal}
      okText="Accept"
      cancelText="Reject"
      closable={false}
      maskClosable={false}
      bodyStyle={{ overflowY: 'auto', maxHeight: '60vh' }}
      centered
      onOk={handleAccept}
      onCancel={handleReject}
    >
      <Paragraph>
        This warning banner provides privacy and security notices consistent
        with applicable federal laws, directives, and other federal guidance for
        accessing this Government system, which includes (1) this computer
        network, (2) all computers connected to this network, and (3) all
        devices and storage media attached to this network or to a computer on
        this network. This system is provided for Government-authorized use
        only.
      </Paragraph>
      <Paragraph>
        Unauthorized or improper use of this system is prohibited and may result
        in disciplinary action and/or civil and criminal penalties. Personal use
        of social media and networking sites on this system is limited as to not
        interfere with official work duties and is subject to monitoring.
      </Paragraph>
      <Paragraph>
        By using this system, you understand and consent to the following: The
        Government may monitor, record, and audit your system usage, including
        usage of personal devices and email systems for official duties or to
        conduct HHS business. Therefore, you have no reasonable expectation of
        privacy regarding any communication or data transiting or stored on this
        system. At any time, and for any lawful Government purpose, the
        government may monitor, intercept, and search and seize any
        communication or data transiting or stored on this system. Any
        communication or data transiting or stored on this system may be
        disclosed or used for any lawful Government purpose.
      </Paragraph>
    </Modal>
  );
};

export default Banner;
